/* FETCH */
export const ADD_EXCEPTION = 'ADD_EXCEPTION';
export const CLEAR_EXCEPTION = 'CLEAR_EXCEPTION';

/* MODELS */
export const ADD_FIELD_DATA = 'ADD_FIELD_DATA';
export const CLEAR_FIELD_DATA = 'CLEAR_FIELD_DATA';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';

/* SETTINGS */
export const ADD_ERROR = 'ADD_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';